import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading3,
  Icon,
  IconVariant,
  Space,
} from '@gousto-internal/citrus-react'

export type BenefitItemProps = {
  title: string
  children: React.ReactNode
}

export function BenefitItem({ title, children }: BenefitItemProps) {
  return (
    <Box display={Display.Flex} alignItems={AlignItems.FlexStart} paddingBottom={4}>
      <Box paddingV={1} paddingRight={3}>
        <Icon name="tick" variant={IconVariant.Confirmation} />
      </Box>
      <Box>
        <Heading3 size={6}>{title}</Heading3>

        <Space size={2} />
        <Body2 size={4}>{children}</Body2>
      </Box>
    </Box>
  )
}
